/**
 * @module Nav
 */
class Nav {

    /**
     * @param {HTMLElement} element - The HTMLElement this module is constructed upon
     * @param {Object} options - ConditionerJS's merged options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this.load();
    }

    /**
     * Construct module
     */
    load() {
        this._toggle = document.querySelector('[data-nav-toggle]');
        this._element.addEventListener('click', evt => this._onClick(evt));
        this._toggle.addEventListener('change', evt => this._onToggle(evt));
    }

    /**
     * On toggle
     * @param {HTMLElement} target
     */
    _onToggle({ target }) {
        if (target.checked) {
            document.documentElement.style.overflow = 'hidden';
            document.documentElement.style.position = 'fixed';
        } else {
            document.documentElement.style.overflow = 'auto';
            document.documentElement.style.position = 'static';
        }
    }

    /**
     * On click
     * @param {HTMLElement} target
     */
    _onClick({ target }) {
        if (target.classList.contains('navigation__item')) {
            target.classList.toggle('navigation__item--open');
        }
    }
}

// Exports
export default Nav;
